import React from "react";
import { Box, Button, styled } from "@mui/material";
import { colors, fontSize, fontWeight, gaps } from "theme/defaultStyle";

interface FilterActionsProps {
  onReset?: () => void;
  onApply?: () => void;
  disableApply?: () => boolean;
}

const FiltersContainer = styled(Box)({
  display: "flex",
  gap: gaps.large1,
  backgroundColor: colors.white,
});

const buttonStyles = {
  padding: "4px 10px !important",
  fontWeight: fontWeight.bold1,
  fontSize: fontSize.medium,
};

const StyledApplyButton = styled(Button)({
  ...buttonStyles,
  color: `${colors.white} !important`,
  ":disabled": {
    backgroundColor: `${colors.blue17} !important`,
    opacity: 1,
  },
});

const StyledResetButton = styled(Button)({
  ...buttonStyles,
  border: `1px solid  ${colors.blue15}`,
});

const FilterActions: React.FC<FilterActionsProps> = ({
  onReset,
  onApply,
  disableApply,
}) => {
  return (
    <FiltersContainer>
      <StyledResetButton onClick={onReset} variant="outlined">
        Reset
      </StyledResetButton>
      <StyledApplyButton
        onClick={onApply}
        variant="contained"
        color="primary"
        disabled={disableApply?.()}
      >
        Apply Filters
      </StyledApplyButton>
    </FiltersContainer>
  );
};
export default FilterActions;
